import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerExportArchivePreTdocModalComponent} from './worker-export-archive-pre-tdoc-modal';

export const WorkerExportArchivePreTdocModalModule: string = ng
  .module('worker-export-archive-pre-tdoc-modal', [
    'ui.bootstrap',
    uiRouter
  ])
  .component('workerExportArchivePreTdocModalComponent', WorkerExportArchivePreTdocModalComponent)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/worker-export-archive-pre-tdoc-modal/worker-export-archive-pre-tdoc-modal.module.ts